<template>
  <div :class="classes">
    <AlertError
      v-if="!isInfo && isError"
      class="alert-icon"
    />
    <AlertWarning
      v-if="!isInfo && !isError"
      class="alert-icon"
    />
    <InfoIcon
      v-if="isInfo"
      class="alert-icon"
    />
    <span
      v-if="message"
      v-html="message"
    />
    <slot
      v-else
    />
  </div>
</template>

<script>
import AlertError from '~/assets/icons/alert_error.svg?component'
import AlertWarning from '~/assets/icons/alert_warning.svg?component'
import InfoIcon from '~/assets/icons/action_info_filled.svg?component'

export default {
  components: {
    AlertError,
    AlertWarning,
    InfoIcon
  },
  props: {
    message: {
      type: String,
      default() {
        return null
      }
    },
    isError: {
      type: Boolean,
      default() {
        return false
      }
    },
    isInfo: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    classes() {
      let messageClass

      if (this.isInfo) {
        messageClass = 'info-message'
      } else if (this.isError) {
        messageClass = 'error-message'
      } else {
        messageClass = 'warning-message'
      }

      return 'warningcontainer--item ' + messageClass
    }
  }
}
</script>

<style lang="scss" scoped>
.warningcontainer--item {
  padding: $default-margin-padding-width-small;
  background-color: $color__content--background__primary;
  font-weight: $base-text-font-weight-light;
  display: flex;
  flex-direction: row;
  align-items: center;

  a {
    font-weight: $base-text-font-weight-semi-bold;
  }

  .icon.infoIcon {
    cursor: default;
  }

  .alert-icon {
    padding-right: .5rem;
    font-size: map-get($base-text-body-medium, font-size );
  }

  span {
    color: $color__text__default;
    word-break: break-word;
  }

  svg {
    position: relative;
    left: -0.125rem;
    height: 1.5rem;
    width: 1.5rem;
    fill: currentcolor;
  }

  &.error-message {
    border: .0625rem solid $color--input__border--error;
    color: $color--input__border--error;

    svg {
      color: $color--input__border--error;
      fill: $color--input__border--error;
    }
  }

  &.warning-message {
    border: .0625rem solid $color__default;
    color: $color__default;

    svg {
      color: $color__default;
      fill: $color__default;
    }
  }

  &.info-message {
    border: .0625rem solid $color__text__default;
    color: $color__text__default;

    svg {
      color: $color__primary;
      fill: $color__primary;
    }
  }
}
</style>
